import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

import scrollama from "scrollama";

export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    // this.infiniteSlider();
    this.mainVisualSlider();
    this.scrollama();
  }

  /**
   * カスタム関数
   */

  mainVisualSlider() {
    if (!$(".c-main-visual.splide").length) return;

    if (sessionStorage.getItem('loading') == null) {
      setTimeout(function(){
        sliderInit();
      }, 3000);

    } else {
      sliderInit();
    }


    function sliderInit() {
      $(".c-main-visual.splide").imagesLoaded(function () {
        var splide = new Splide( '.c-main-visual.splide', {
          type: "fade",
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: false,
          drag: false,
          autoplay: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          rewind: true,
          interval: 10000,
          speed: 20000,
          loop:true,

          reducedMotion: {
            autoplay: true,
            interval: 10000,
            speed: 20000,
          }
        }).mount();
      });

      $(".c-main-visual__inner.splide").imagesLoaded(function () {
        var splideInner = new Splide( '.c-main-visual__inner.splide', {
          type: "fade",
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: false,
          drag: false,
          autoplay: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          rewind: true,
          interval: 20000,
          speed: 3000,
          loop:true,

          reducedMotion: {
            autoplay: true,
            interval: 20000,
            speed: 3000,
          }
        }).mount();
      })
    }
  }

  scrollama() {

    let $target = $(".c-block-story");

    if ($target.length === 0) {
      return false;
    }

    const scroller1 = scrollama();
    const scroller2 = scrollama();
    const scroller3 = scrollama();

    scroller1
      .setup({
        step: ".js-scrollspy-section1",
        offset: 0,
      })
      .onStepEnter((response) => {
        $(".c-block-story__bg.is-active").addClass("is-curtain");
        $(".c-block-story__bg").eq(0).addClass("is-active");
        $(".c-block-story__bg").eq(1).removeClass("is-active");
      })
      .onStepExit((response) => {
        $(".c-block-story__bg").eq(0).removeClass("is-curtain");
    });

    scroller2
      .setup({
        step: ".js-scrollspy-section2",
        offset: 0,
      })
      .onStepEnter((response) => {
        $(".c-block-story__bg").eq(1).addClass("is-active");
        $(".c-block-story__bg.is-active").removeClass("is-curtain");
      })
      .onStepExit((response) => {
        // $(".c-block-story__bg").eq(1).removeClass("is-curtain");
      });

    scroller3
      .setup({
        step: ".js-scrollspy-section3",
        offset: 0,
      })
      .onStepEnter((response) => {
        $(".c-block-story__bg").eq(1).addClass("is-active");
        $(".c-block-story__bg.is-active").addClass("is-curtain");
      })
      .onStepExit((response) => {

      });
  }

  // ループスライダー
  infiniteSlider() {
    const optionInfinite = {
      infinite: true,
      arrows: false,
      swipe: false,
      dots: false,
      variableWidth: true,  // スライド幅の自動計算を無効
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false
    }
    const slickInfinite = $('.js-infinite-slider');
    if (slickInfinite) $(slickInfinite).slick(optionInfinite);
  }

  // 複製して作業
  mycode() {

  }


}




